import React from "react";
import { Check } from "react-feather";
import Popup from "~/assets/js/components/Popup";
import Button from "~/assets/js/components/Button";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import i18n from "~/assets/js/Helpers/i18n";
import { IntoleranceFiltersOptionsTypes } from "../types";

const IntoleranceFilterOptions = ({
    open,
    selectedFilters,
    onSelect,
    handleClose,
    handleClear,
    intolerances,
    onFilter,
}) => {
    const { isMobile } = useViewport();

    const popupConfig = {
        open: open,
        customStyle: "intolerance-filter_popup",
        handleClose: handleClose,
        isClosable: true,
    };

    if (!open) {
        return null;
    }

    const isClearBtnActive = selectedFilters.length > 0;

    if (isMobile) {
        return (
            <Popup {...popupConfig}>
                <div className="intolerance-filter__options">
                    <ul>
                        {intolerances.map((intolerance) => {
                            return (
                                <li
                                    onClick={() => onSelect(intolerance.id)}
                                    key={intolerance.id}
                                    className={`intolerance-filter__options-option ${
                                        selectedFilters.includes(
                                            intolerance.id
                                        ) && "selected"
                                    }`}
                                >
                                    <p>{intolerance.label}</p>
                                    <Check color={"#00E940"} />
                                </li>
                            );
                        })}
                    </ul>
                    <div className="intolerance-filter__options-cta">
                        <span
                            onClick={handleClear}
                            className={`${isClearBtnActive ? "active" : ""}`}
                        >
                            {i18n.t("intoleranceFilters.clear")}
                        </span>
                        <Button
                            label={i18n.t("form.label.save")}
                            variant={"secondary"}
                            size={"XS"}
                            onClick={() => {
                                onFilter(selectedFilters);
                                handleClose();
                            }}
                        />
                    </div>
                </div>
            </Popup>
        );
    }

    return (
        <div className="intolerance-filter__options">
            <ul>
                {intolerances.map((intolerance) => {
                    return (
                        <li
                            onClick={() => onSelect(intolerance.id)}
                            key={intolerance.id}
                            className={`intolerance-filter__options-option ${
                                selectedFilters.includes(intolerance.id) &&
                                "selected"
                            }`}
                        >
                            <p>{intolerance.label}</p>
                            <Check color={"#00E940"} />
                        </li>
                    );
                })}
            </ul>
            <div className="intolerance-filter__options-cta">
                <span
                    className={`${isClearBtnActive ? "active" : ""}`}
                    onClick={handleClear}
                >
                    {i18n.t("intoleranceFilters.clear")}
                </span>
                <Button
                    label={i18n.t("form.label.save")}
                    variant={"secondary"}
                    size={"XS"}
                    onClick={() => {
                        onFilter(selectedFilters);
                        handleClose();
                    }}
                />
            </div>
        </div>
    );
};

export default IntoleranceFilterOptions;

IntoleranceFilterOptions.propTypes = IntoleranceFiltersOptionsTypes;
